// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupItem__status-c61fb7 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
}

.GroupItem__pin-f68dc3 {
  width: 24px;
  height: 24px;
  fill: var(--base-60);
}

.GroupItem__mention-fba848 {
  width: 16px;
  height: 16px;
  fill: var(--brand-primary-40);
}

.GroupItem__unlock-button-a8ec71 {
  max-height: 32px;
}

.GroupItem__bell-icon-be131e {
  background-color: var(--warning-40);
  color: var(--addition-50);
  padding: 4px;
  border-radius: 50%;
  min-width: 16px;
  fill: currentColor;
}

.GroupItem__blocked-description-a6ee49 {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/GroupList/GroupItem/GroupItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,4CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,mCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF","sourcesContent":[".status {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle);\n}\n\n.pin {\n  width: 24px;\n  height: 24px;\n  fill: var(--base-60);\n}\n\n.mention {\n  width: 16px;\n  height: 16px;\n  fill: var(--brand-primary-40);\n}\n\n.unlock-button {\n  max-height: 32px;\n}\n\n.bell-icon {\n  background-color: var(--warning-40);\n  color: var(--addition-50);\n  padding: 4px;\n  border-radius: 50%;\n  min-width: 16px;\n  fill: currentColor;\n}\n\n.blocked-description {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `GroupItem__status-c61fb7`,
	"pin": `GroupItem__pin-f68dc3`,
	"mention": `GroupItem__mention-fba848`,
	"unlock-button": `GroupItem__unlock-button-a8ec71`,
	"unlockButton": `GroupItem__unlock-button-a8ec71`,
	"bell-icon": `GroupItem__bell-icon-be131e`,
	"bellIcon": `GroupItem__bell-icon-be131e`,
	"blocked-description": `GroupItem__blocked-description-a6ee49`,
	"blockedDescription": `GroupItem__blocked-description-a6ee49`
};
module.exports = ___CSS_LOADER_EXPORT___;
